interface UpdateItem {
  date: string;
  tag: string;
  title: string;
  summary: string;
}

const updates: UpdateItem[] = [
  {
    date: '2026-07-30',
    tag: '地址更新',
    title: '91樱花最新网址已更新，当前入口全面恢复访问',
    summary: '本次更新覆盖主域名及备用线路，所有入口经测试均正常可用，建议及时收藏新地址。',
  },
  {
    date: '2026-07-29',
    tag: '新番上线',
    title: '七月新番专区全面上线，多部热门作品同步收录',
    summary: '本季热门新番已全部整理入库，包括多部备受期待的续作与原创动画，追番不迷路。',
  },
  {
    date: '2026-07-28',
    tag: '线路优化',
    title: '海外加速线路部署完成，访问速度提升明显',
    summary: '针对海外用户新增多条CDN加速节点，缓冲等待时间大幅缩短，看片体验更流畅。',
  },
  {
    date: '2026-07-27',
    tag: '功能更新',
    title: '收藏夹功能升级，支持跨设备同步追番进度',
    summary: '登录后可将收藏的动漫同步到任意设备，换手机换电脑都不怕丢失追番记录。',
  },
  {
    date: '2026-07-26',
    tag: '地址更新',
    title: '备用域名已就绪，多入口保障访问不中断',
    summary: '新增三个备用访问入口，主域名如遇波动可无缝切换，确保动漫访问不间断。',
  },
  {
    date: '2026-07-25',
    tag: '专题策划',
    title: '「樱花季经典回顾」专题上线，精选百部佳作',
    summary: '整理了历年高分经典动漫作品，涵盖热血、治愈、悬疑等多种类型，一次看个够。',
  },
  {
    date: '2026-07-24',
    tag: '安全提示',
    title: '谨防仿冒钓鱼网站，认准91樱花官方认证入口',
    summary: '近期发现多个仿冒站点，请务必通过本站提供的链接访问，切勿轻信搜索引擎推广结果。',
  },
  {
    date: '2026-07-23',
    tag: '社区动态',
    title: '用户评论区功能开放，追番交流两不误',
    summary: '每部动漫详情页新增评论区，可以和其他漫迷一起讨论剧情、分享感受。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">实时快讯</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">第一时间了解91樱花最新网址变动、新番上线与站点动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary-200 -translate-x-1/2 hidden md:block"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="flex-1 hidden md:block"></div>

                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>

                <div className="flex-1 bg-background-100 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}